import React from "react"
import { graphql } from "gatsby"

import CmsPage from "@utils/cmsPage"
import { pickCollectionNode } from "@utils/cmsCollections"
import productSubpageMobileStyles from "@utils/productSubpageMobileStyles"
import { getPrototypePageSlice } from "@utils/prototypeSlices"

const prototypeSlice = getPrototypePageSlice("automation")
const automationExtraStyles = `${prototypeSlice.extraStyles}${productSubpageMobileStyles}

.cms-page .aa-node-meta {
  align-items: center;
  display: inline-flex;
  gap: 6px;
}

@media (max-width: 960px) {
  .cms-page .aa-node-ttl {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }

  .cms-page .aa-node-meta {
    justify-content: flex-start;
    text-align: left;
    width: 100%;
  }

  .cms-page .aa-node-desc {
    margin-left: 0;
    margin-right: 0;
    text-align: left;
  }

  .cms-page .aa-builder-stage {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  .cms-page .aa-bridge {
    flex-direction: column;
    justify-content: center;
    padding: 0;
  }

  .cms-page .aa-bridge-line {
    width: 2px;
    height: 42px;
    background: linear-gradient(180deg, #ccfbf1, #14b8a6);
    overflow: visible;
  }

  .cms-page .aa-bridge-line::before {
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    animation: aaBridgeVertical 1.8s linear infinite;
  }

  .cms-page .aa-bridge-line::after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 50%;
    width: 7px;
    height: 7px;
    border-right: 2px solid #14b8a6;
    border-bottom: 2px solid #14b8a6;
    transform: translateX(-50%) rotate(45deg);
  }

  .cms-page .aa-bridge svg {
    display: none;
  }

  .cms-page .aa-bridge .lbl {
    margin: 10px 0;
  }

  @keyframes aaBridgeVertical {
    from {
      top: 0;
      transform: translate(-50%, 0);
    }
    to {
      top: 100%;
      transform: translate(-50%, -100%);
    }
  }
}
`

const AutomationPage = ({ data }) => {
  const page = data.allDatoCmsMcV2PageFeatureDeep.nodes[0] || {}
  const sectionCollection =
    page.sectionCollection ||
    pickCollectionNode(data.allDatoCmsMcV2SectionCollection.nodes, null, "automation-sections")
  const hasCanonicalContent = Boolean(page.contentHtml)

  return (
    <CmsPage
      slug={page.slug}
      seo={page.seo}
      hideHero
      preserveHeroScripts
      eyebrow={page.eyebrow}
      heading={page.heading}
      summary={page.summary}
      body={page.body}
      bodyHeading={page.bodyHeading || "Feature Deep Dive"}
      heroMediaType={page.heroMediaType}
      heroImageUrl={page.heroImageUrl}
      heroImageAlt={page.heroImageAlt}
      heroVideoUrl={page.heroVideoUrl}
      heroVideoPosterUrl={page.heroVideoPosterUrl}
      contentSections={sectionCollection.contentSections || []}
      contentHtml={page.contentHtml}
      fallbackContentHtml={prototypeSlice.contentHtml}
      extraStyles={automationExtraStyles}
      extraHeadLinks={prototypeSlice.extraHeadLinks}
      emptyMessage="Create or seed the automation record in mc_v2_page_feature_deep."
    />
  )
}

export default AutomationPage

export const query = graphql`
  query AutomationCmsPageQuery {
    allDatoCmsMcV2PageFeatureDeep(filter: { slug: { eq: "automation" } }, limit: 1) {
      nodes {
        seo {
          ...CmsSeoFields
        }
        slug
        eyebrow
        heading
        summary
        body
        # bodyHeading  # TODO(T-014 add the Dato field, T-015 then uncomment): blocked on DatoCMS schema
        heroMediaType
        heroImageUrl
        heroImageAlt
        heroVideoUrl
        heroVideoPosterUrl
        contentHtml
        sectionCollection {
          contentSections {
            ...CmsHtmlSectionFields
          }
        }
      }
    }
    allDatoCmsMcV2SectionCollection {
      nodes {
        key
        contentSections {
          ...CmsHtmlSectionFields
        }
      }
    }
  }
`
